import React from "react";
import "./index.scss";

import img_roadmap_enlarge from "@/assets/img/img_roadmap_enlarge.png";
import img_roadmap_enlarge_reversed from "@/assets/img/img_roadmap_enlarge_reversed.png";

interface IProps {
	pcode: string;
	prop: string;
	reversed: boolean;
	toggleEnlargeRoadmap: (e: any) => void;
}

export default class RoadmapEnlargeButton extends React.Component<IProps> {
	state = {isHovering : false};
	
	setHoverClass() {
		this.setState({isHovering: true});
	}
	
	removeHoverClass() {
		this.setState({isHovering: false});
	}
	
	render() {
		return (
			<div className={"enlargement-area" + (this.props.reversed ? " enlarged" : "")}
				 onMouseOver={this.setHoverClass.bind(this)}
				 onMouseLeave={this.removeHoverClass.bind(this)}>
				<img className={"toggle-enlarge-roadmap" + (this.state.isHovering ? " hovering" : "")}
					src={this.props.reversed ? img_roadmap_enlarge_reversed : img_roadmap_enlarge}
					alt="maximise"
					 />
				
				<div className="hover-area"

					{...{
						prop: this.props.prop,
						pcode: this.props.pcode
					}}

					onClick={this.props.toggleEnlargeRoadmap}
					/>
			</div>
		);
	}
}